import { MetabaseCard } from '@shared/components/metabase';

export class ProjectReportModel extends MetabaseCard {}
